(function () {

    'use strict';

    var Randomize = {
        $wrapper: $('.create-items'),
        $items: $('.create-item'),
        $lastItem: undefined,
        lastNumber: undefined,
        lastTimeout: 0,
        shuffling: false,
        loops: 20,
        timeoutBase: 16,
        init: function () {
            this.bindEvents();
        },
        bindEvents: function () {
            var self = this;
            $('.randomize').on('click', function(e) {
                e.preventDefault();
                if (!self.shuffling) {
                    self.randomize();
                }
            });
        },
        randomize: function () {
            var self = this,
                offset = this.$wrapper.offset().top + this.$wrapper.height() / 2 - window.innerHeight / 2;
            this.shuffling = true;
            self.$wrapper.addClass('randomized');
            $('html, body').animate({
                scrollTop: offset
            }, 400);
            setTimeout(function() {
                self.shuffle();
            }, 600);
        },
        shuffle: function () {
            for (var i = 0; i < this.loops; i++) {
                this.selectItem(i, i === this.loops - 1);
            }
        },
        selectItem: function (i, last) {
            var self = this;
            this.lastTimeout += this.timeoutBase * i;
            setTimeout(function () {
                self.getRandomNumber();
                var $item = self.$items.removeClass('active')
                    .eq(self.lastNumber).addClass('active');
                if (last) {
                    self.endOnItem($item);
                }
            }, this.lastTimeout);
        },
        getRandomNumber: function () {
            var rand = Math.floor(Math.random() * this.$items.length);
            if (this.lastNumber !== rand) {
                this.lastNumber = rand;
            } else {
                this.getRandomNumber();
            }
            // return this.lastNumber !== rand ? rand : this.getRandomNumber();
        },
        endOnItem: function ($item) {
            var self = this,
                count = 0,
                interval,
                navHeight = $('.navbar-main').height(),
                itemOffset = $item.offset().top,
                itemHeight = $item.height(),
                offset = itemOffset + itemHeight / 2 - window.innerHeight / 2;
            if (itemOffset - navHeight < $(window).scrollTop() ||
                itemOffset + itemHeight > $(window).scrollTop() + window.innerHeight) {
                    $('html, body').animate({
                        scrollTop: offset
                    }, 400);
            }
            interval = setInterval(function () {
                $item.toggleClass('active');
                count++;
                if (count === 8) {
                    clearInterval(interval);
                    self.lastTimeout = 0;
                    self.shuffling = false;
                }
            }, 200);
        }
    };
    Randomize.init();

})(window);